import { CloudinaryUploadResponse } from "@/shared/utils/interfaces";
import { useMutation } from "@tanstack/react-query";
import axios, { AxiosResponse } from "axios";

interface Body {
  upload_url: string;
  res: FormData;
}

const useUploadCloudinaryHook = () => {
  const mutation = useMutation({
    mutationFn: async ({ upload_url, res }: Body) => {
      const { data } = await axios.post<
        any,
        AxiosResponse<CloudinaryUploadResponse>
      >(upload_url, res, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return data;
    },
  });
  return mutation;
};

export default useUploadCloudinaryHook;
